import { register } from "@rill/loader";

register(
  {
    name: "planManager",
    meta: ["no-bust", "plan-manager"],
    ttl: "2 hours",
  },
  async ({ api, locals }) => {
    let query = {};
    if (locals.activeUser.organizationId) {
      query = {
        ...query,
        organizationUser: locals.activeUserToRequest._id,
      };
    }
    const res = await api("coach-plan-manager", { query });
    const data = await res.json();
    return data;
  }
);

register(
  {
    name: "stripeCoupon",
  },
  async ({ api, locals }) => {
    let query = {};
    if (locals.activeUser.organizationId) {
      query = {
        ...query,
        organizationUser: locals.activeUserToRequest._id,
      };
    }
    const res = await api("stripe-coupon", { query });
    const data = await res.json();
    return data;
  }
);
